module.exports = __webpack_public_path__ + "img/tuijianchapin.25f412a6.png";